import { render, staticRenderFns } from "./scorecard-order.vue?vue&type=template&id=22a8b3d0&scoped=true"
import script from "./scorecard-order.vue?vue&type=script&lang=js"
export * from "./scorecard-order.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order.vue?vue&type=style&index=0&id=22a8b3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8b3d0",
  null
  
)

export default component.exports